import React from 'react';
import { StatusBadge } from '../insurance/formBits';
import { statusTone } from '../../insurance/claims';

// The claim's status as a tinted pill, using the API's label when it sends one.
export default function ClaimStatusBadge({ status, statusLabel }) {
  return <StatusBadge tone={statusTone(status)}>{statusLabel || status}</StatusBadge>;
}
